let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5ftH5")).then(() => parcelRequire('hTktu'));